module.exports = "<div class=\"js-dropdown-region editor\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/multiSelectEditor.hbs
// module id = 690
// module chunks = 0